export default (fill) => (
  `<svg version="1.1" id="Слой_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 102 110" enable-background="new 0 0 102 110" xml:space="preserve">
<g id="Стилеобразующие-элементы-услуг">
	<g id="_x37_" transform="translate(-721.000000, -668.000000)">
		<g id="biblio" transform="translate(721.000000, 668.000000)">
			<path fill="${fill? fill : '#E77A2B'}" id="Fill-1" d="M101,36.5c-0.6-5.7-4.8-13-9.3-16.4c0,0-6.8-5-15.2-10c-8.5-5-16.1-8.4-16.1-8.4
				C57.7,0.6,54.4,0,51,0c-3.4,0-6.7,0.6-9.3,1.7c0,0-7.6,3.4-16.1,8.4c-8.5,5-15.2,10-15.2,10C5.8,23.5,1.6,30.9,1,36.5
				c0,0-0.9,8.5-0.9,18.4c0,10,0.9,18.4,0.9,18.4c0.6,5.7,4.8,13,9.3,16.4c0,0,6.8,5,15.2,10c8.5,5,16.1,8.4,16.1,8.4
				c2.6,1.2,5.9,1.7,9.3,1.7c3.4,0,6.7-0.6,9.3-1.7c0,0,7.6-3.4,16.1-8.4c8.5-5,15.2-10,15.2-10c4.5-3.4,8.7-10.7,9.3-16.4
				c0,0,0.9-8.5,0.9-18.4C101.8,45,101,36.5,101,36.5L101,36.5z M96.3,72.8c-0.5,4.4-3.9,10.5-7.4,13.1c-0.1,0-6.7,4.9-14.8,9.7
				c-8.1,4.8-15.6,8.1-15.7,8.2c-1.9,0.8-4.5,1.3-7.4,1.3c-2.8,0-5.5-0.5-7.4-1.3c-0.1,0-7.5-3.4-15.7-8.2
				C19.8,90.9,13.2,86,13.1,86c-3.5-2.6-7-8.7-7.4-13.1c0-0.1-0.9-8.3-0.9-17.9c0-9.6,0.9-17.8,0.9-17.9c0.5-4.4,3.9-10.5,7.4-13.1
				c0.1,0,6.6-4.9,14.8-9.7C36.1,9.4,43.5,6,43.6,6c1.9-0.8,4.5-1.3,7.4-1.3c2.8,0,5.5,0.5,7.4,1.3c0.1,0,7.5,3.4,15.7,8.2
				c8.1,4.8,14.7,9.7,14.8,9.7c3.5,2.6,7,8.7,7.4,13.1c0,0.1,0.9,8.3,0.9,17.9C97.2,64.5,96.3,72.7,96.3,72.8L96.3,72.8z"/>
			<path fill="${fill? fill : '#E77A2B'}"  d="M68.3,83h-34c-1.7,0-3.2-1.4-3.2-3.2V30.4c0-1.7,1.4-3.2,3.2-3.2h34c1.8,0,3.2,1.4,3.2,3.2v49.4
				C71.5,81.6,70,83,68.3,83z M35.1,79h32.3V45.6H35.1V79z M35.1,41.2h32.3v-10H35.1V41.2z"/>
			<path fill="${fill? fill : '#E77A2B'}"  d="M62,38.4H39.7c-1.1,0-2-0.9-2-2s0.9-2,2-2H62c1.1,0,2,0.9,2,2S63.1,38.4,62,38.4z"/>
			<path fill="${fill? fill : '#E77A2B'}"  d="M42,61.6c-0.3,0-0.7-0.1-1-0.3c-0.6-0.4-1-1-1-1.7V43.2c0-1.1,0.9-2,2-2h12.5c1.1,0,2,0.9,2,2v16.4
				c0,0.7-0.4,1.4-1,1.7c-0.6,0.4-1.4,0.4-2,0l-5.3-3l-5.3,3C42.7,61.5,42.3,61.6,42,61.6z M48.3,54.1c0.3,0,0.7,0.1,1,0.3l3.3,1.8
				V45.2H44v10.9l3.3-1.8C47.6,54.2,47.9,54.1,48.3,54.1z"/>
		</g>
	</g>
</g>
</svg>
`
)


// WEBPACK FOOTER //
// ./components/Icon/icons/uslugas/42.jsx